import { PopupCommentData } from "../interfaces/dto";

const { findHtmlEl, findHtmlEls } = pm.utils.dom;

export default function renderCommentData(
	commentListWrapper: HTMLElement,
	commentListItem: HTMLElement,
	popupCommentData: PopupCommentData,
) {
	commentListItem.classList.add("comment-list-item");

	const isLoggedIn = popupCommentData.isLoggedIn;
	const isCommentAuthor = popupCommentData.isCommentAuthor;

	renderByLoginState(commentListItem, true, isLoggedIn);
	renderByLoginState(commentListItem, false, isLoggedIn);
	renderIfCommentAuthor(commentListItem, isCommentAuthor);
	renderIfNotCommentAuthor(commentListItem, isCommentAuthor);
	renderTemplateTags(commentListItem, popupCommentData);
	parseIsLiked(commentListItem, popupCommentData.commentIsLiked);
	parseTotalLikes(commentListItem, popupCommentData.commentTotalLikes);

	commentListItem.classList.remove("is-hidden");
	commentListWrapper.appendChild(commentListItem);
}

function renderByLoginState(
	area: HTMLElement,
	shouldLogin: boolean,
	isCurrentlyLoggedIn: boolean,
) {
	const els = shouldLogin
		? findHtmlEls(area, "[data-render-if-is-logged-in]")
		: findHtmlEls(area, "[data-render-if-not-logged-in]");

	if (!els.length) return;

	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		if (shouldLogin && !isCurrentlyLoggedIn) {
			el.parentNode!.removeChild(el);
		} else {
			if (!shouldLogin && isCurrentlyLoggedIn) {
				el.parentNode!.removeChild(el);
			}
		}
	}
}

function renderIfCommentAuthor(area: HTMLElement, isCommentAuthor: boolean) {
	const els = findHtmlEls(area, "[data-render-if-comment-author]");
	if (!els.length) return;

	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		if (!isCommentAuthor) {
			el.parentNode!.removeChild(el);
		}
	}
}

function renderIfNotCommentAuthor(area: HTMLElement, isCommentAuthor: boolean) {
	const els = findHtmlEls(area, "[data-render-if-not-comment-author]");
	if (!els.length) return;

	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		if (isCommentAuthor) {
			el.parentNode!.removeChild(el);
		}
	}
}

function renderTemplateTags(area: HTMLElement, data: PopupCommentData) {
	renderTemplateTagsForAttr(area, data);

	const elsFromAttr = findHtmlEls(area, "[data-attr-has-template-tags]");

	if (elsFromAttr.length) {
		for (let i = 0; i < elsFromAttr.length; i++) {
			const el = elsFromAttr[i];
			renderTemplateTagsForAttr(el, data);
		}
	}

	const elsFromText = findHtmlEls(area, "[data-text-has-template-tags]");

	if (elsFromText.length) {
		for (let i = 0; i < elsFromText.length; i++) {
			const el = elsFromText[i];
			renderTemplateTagsForContent(el, data, false);
		}
	}

	const elsFromContent = findHtmlEls(area, "[data-content-has-template-tags]");

	if (elsFromContent.length) {
		for (let i = 0; i < elsFromContent.length; i++) {
			const el = elsFromContent[i];
			renderTemplateTagsForContent(el, data, true);
		}
	}
}

const attributesToParse = ["id", "class", "href", "src"];

function renderTemplateTagsForAttr(el: HTMLElement, data: PopupCommentData) {
	for (let i = 0; i < attributesToParse.length; i++) {
		const attr = attributesToParse[i];

		if (el.hasAttribute(attr)) {
			const attrName = el.getAttribute(attr);

			if (attrName) {
				const attrContent = parseTemplateTags(attrName, data);

				if (attrContent) {
					el.setAttribute(attr, attrContent);
				}
			}
		}
	}

	const datasets = el.dataset;

	for (const key in datasets) {
		if (datasets.hasOwnProperty(key)) {
			const value = datasets[key];

			if (value) {
				el.dataset[key] = parseTemplateTags(value, data);
			}
		}
	}
}

function renderTemplateTagsForContent(
	el: HTMLElement,
	data: PopupCommentData,
	useInnerHTML: boolean,
) {
	let content = useInnerHTML ? el.innerHTML : el.textContent;

	if (content) {
		content = parseTemplateTags(content, data);
		el.innerHTML = content;
	}
}

function parseTemplateTags(content: string, data: PopupCommentData): string {
	if (!content) return content;
	let parsed = content;

	// Loop through data and replace the tags with the data.
	for (const key in data) {
		if (data.hasOwnProperty(key)) {
			// @ts-ignore
			const value = data[key];
			const kebabCasedKey = pm.utils.str.camelCaseToKebabCase(key);
			parsed = parsed.replace(`{${kebabCasedKey}}`, value);
		}
	}

	return parsed;
}

function parseIsLiked(commentListItem: HTMLElement, isLiked: boolean) {
	const likeButton = findHtmlEl(commentListItem, ".like-button.like-comment");

	if (likeButton) {
		if (isLiked) {
			likeButton.classList.add("is-liked");
		} else {
			likeButton.classList.remove("is-liked");
		}

		const svgTitleEl = findHtmlEl(likeButton, "svg title");

		if (svgTitleEl) {
			const likedTitle = likeButton.dataset.likedTitle
				? likeButton.dataset.likedTitle
				: "";
			const unlikedTitle = likeButton.dataset.unlikedTitle
				? likeButton.dataset.unlikedTitle
				: "";

			svgTitleEl.innerHTML = isLiked ? likedTitle : unlikedTitle;
		}
	}
}

function parseTotalLikes(commentListItem: HTMLElement, totalLikes: number) {
	const totalLikesEl = findHtmlEl(
		commentListItem,
		".comment-likes .total-likes",
	);

	if (totalLikesEl) {
		totalLikesEl.textContent = totalLikes.toString();

		if (totalLikes) {
			totalLikesEl.classList.remove("is-hidden");
		} else {
			totalLikesEl.classList.add("is-hidden");
		}
	}
}
